import gql from 'graphql-tag';
import { getCurrentUserId } from '@shootsta/common-react';

const getVideoCountQuery = gql`
  query GetVideoCountCreatedByUser($createdByUserId: String) {
    getVideoCount(createdByUserId: $createdByUserId)
  }
`;

const getVideoCountCreatedByUser = () => ({
  query: getVideoCountQuery,
  module: 'video',
  ignoreCache: true,
  buildVariables: () => ({
    createdByUserId: getCurrentUserId()
  })
});

export default getVideoCountCreatedByUser;
